import Conf from 'conf';

const config = new Conf({ projectName: 'superpush' });

export function setKey(key: string, value: any) {
  config.set(key, value);
}

export function getKey(key: string): any {
  return config.get(key);
}

export function deleteKey(key: string) {
  config.delete(key);
}
